import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ShipmentPlannerProfileModel } from '../models';
import { ShipmentPlannerProfileEndpoint } from '../constants/shipment-planner-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileItemService {
  constructor(private http: WrapperHttpService) {}

  setShipmentProfileItemDefaultProfileToggle({
    profileId,
    isDefault,
  }: {
    profileId: number;
    isDefault: boolean;
  }): Observable<boolean> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}${ShipmentPlannerProfileEndpoint.Default}`;

    return this.http.withLoading().put<boolean>(url, { profileId, isDefault });
  }

  getShipmentDefaultProfile(): Observable<ShipmentPlannerProfileModel> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}${ShipmentPlannerProfileEndpoint.Default}`;
    return this.http.withLoading().get<ShipmentPlannerProfileModel>(url);
  }

  getShipmentPlannerProfile(id: number): Observable<ShipmentPlannerProfileModel> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<ShipmentPlannerProfileModel>(url);
  }

  createShipmentPlannerProfile(body: Partial<ShipmentPlannerProfileModel>): Observable<ShipmentPlannerProfileModel> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<ShipmentPlannerProfileModel>(url, body);
  }

  updateShipmentPlannerProfile(body: Partial<ShipmentPlannerProfileModel>): Observable<ShipmentPlannerProfileModel> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<ShipmentPlannerProfileModel>(url, body);
  }
}
